/**
 * THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY
 * To add new icons to the system, or to update existing icons, run `clyde mana assets sync -t icons`.
 */

import * as React from 'react';
import tokens from '@discordapp/tokens/web';

import addDefaultIconProps from '../addDefaultIconProps';
import {getIconSize} from '../getIconSize';

import type {SingleColorIconProps} from '../IconTypes';

/**
 * ![RedoIcon](data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAACXBIWXMAAAsTAAALEwEAmpwYAAABEklEQVR4nO1SLUtEURB9oIhZg4gWu90ivCo858zcMDsjiyz+Cv+Awe4/0GKx2C0ugljEYLNpMIjJYPBjue57sLC86wsW4R645c6Zc+arKDIy/jeIfInY9sF2AbFnYv+A2CuJXUP8sAq99akc8SuwDZPC5WAwT+wHEH+H+HfifZH4qaouNLlNrFU8hP4y2G8iidg+wX4GeIj/qjpHpGsUfAtsJxMFPG3LzuavBrESEr8fi/sD4BupTkPor5L45VjU3iI/aUBi5zX5TmR3MTnHZpxlOQvx47rjx1YDZrOa9FJVutJFfHJnzVhbDUjs9ieI3l7RARSvJXEAUwlgP4oLVdWZLgZgG7aJx7100cjIyCj+BiPVSKFn/1boMQAAAABJRU5ErkJggg==)
 */
export const RedoIcon = ({
  size = 'md',
  width,
  height,
  color = tokens.colors.INTERACTIVE_NORMAL,
  colorClass = '',
  ...props
}: SingleColorIconProps) => {
  const iconSize = getIconSize(size);
  const iconWidth = iconSize?.width ?? width;
  const iconHeight = iconSize?.height ?? height;
  return (
    <svg
      {...addDefaultIconProps(props)}
      xmlns="http://www.w3.org/2000/svg"
      width={iconWidth}
      height={iconHeight}
      fill="none"
      viewBox="0 0 24 24">
      <path
        fill={typeof color === 'string' ? color : color.css}
        d="M22 8a1 1 0 1 0-2 0v3.54A10.26 10.26 0 0 0 11.63 7c-4.24 0-7.84 2.74-9.54 6.6a1 1 0 0 0 1.82.8C5.36 11.15 8.31 9 11.63 9a8.34 8.34 0 0 1 6.95 4H15a1 1 0 1 0 0 2h6a1 1 0 0 0 1-1V8Z"
        className={colorClass}
      />
    </svg>
  );
};
